// Interfaces
import { IDropdown } from 'interfaces/common'

/**
 * @description Asynchronous delay
 *
 * @param {number} ms
 *
 * @return {Promise<any>} Promise<any>
 */
export const commonUtils_delay = (ms: number) => new Promise(res => setTimeout(res, ms))

/**
 * @description Remove value in flat array
 *
 * @param {any[]} values
 *
 * @return {any[]} any[]
 */
export const commonUtils_removeDuplicateFlatten = (values: any[]): any[] => {
  return values.filter(function (item, pos, self) {
    return self.indexOf(item) === pos
  })
}

/**
 * @description Remove value in array of object
 *
 * @param {any[]} array
 * @param {string} byKey
 *
 * @return {any}
 */
export const commonUtils_preventDuplicate = (array: any[], byKey: string) => {
  return array.filter((data, index, self) => index === self.findIndex(t => t[byKey] === data[byKey]))
}

/**
 * @description Handle select option selected value
 *
 * @param {IDropdown[]} dropdown
 * @param {number|string|boolean|null} value
 * @param {string} featureName
 *
 * @return {string|undefined} string undefined
 */
export const commonUtils_handleSelectOptionValue = (
  dropdown: IDropdown[],
  value: number | string | boolean | null,
): string | undefined => {
  const dropdownValue =
    dropdown.length === 0
      ? undefined
      : dropdown.find(result => result.value === value?.toString())
      ? value?.toString()
      : undefined

  return dropdownValue
}

/**
 * @description Slice phone number
 *
 * @param {string} phoneNumber
 *
 * @return {string} string
 */
export const commonUtils_phoneNumber = (phoneNumber: string) => {
  // Check if phone number includes 62
  if (['62'].includes(`${phoneNumber?.[0]}${phoneNumber?.[1]}`)) {
    return phoneNumber.slice(2)
  }

  // Check if phone number includes 620
  if (['620'].includes(`${phoneNumber?.[0]}${phoneNumber?.[1]}${phoneNumber?.[2]}`)) {
    return phoneNumber.slice(3)
  }

  // Check if phone number includes 0, 6, 2
  if (['0', '6', '2'].includes(phoneNumber?.[0])) {
    return phoneNumber.slice(1)
  }

  return phoneNumber
}

/**
 * @description Handle empty user photo
 *
 * @param {object} photo
 *
 * @return {object}
 */
export const commonUtils_emptyUserPhoto = ({
  profilePhoto,
  idCardPhoto,
  bachelorCertificatePhoto,
  familyCardPhoto,
  workCardPhoto,
}: {
  profilePhoto?: string | null
  idCardPhoto?: string | null
  bachelorCertificatePhoto?: string | null
  familyCardPhoto?: string | null
  workCardPhoto?: string | null
}): {
  profilePhoto: string | null
  idCardPhoto: string | null
  bachelorCertificatePhoto: string | null
  familyCardPhoto: string | null
  workCardPhoto: string | null
} => {
  return {
    profilePhoto: profilePhoto === 'images/Datadiri/Profile/' || !profilePhoto?.split(',')?.[1] ? '' : profilePhoto,
    idCardPhoto: idCardPhoto === 'images/Datadiri/IDCard/' || !idCardPhoto?.split(',')?.[1] ? '' : idCardPhoto,
    bachelorCertificatePhoto: !bachelorCertificatePhoto ? '' : bachelorCertificatePhoto,
    familyCardPhoto: !familyCardPhoto ? '' : familyCardPhoto,
    workCardPhoto: !workCardPhoto ? '' : workCardPhoto,
  }
}

/**
 * @description Download base64 image
 *
 * @param {string} base64String
 * @param {string} fileName
 *
 * @return {void} void
 */
export const commonUtils_downloadBase64 = (base64String: string, fileName: string): void => {
  let a = document.createElement('a')
  a.href = base64String
  a.download = `${fileName}.${base64String?.split(',')?.[0]?.split('/')?.[1]?.split(';')?.[0]}`
  a.click()
}

/**
 * @description Count number of index inside pagination
 *
 * @param {number} index
 * @param {object} options
 *
 * @return {number} number
 */
export const commonUtils_renderTableNumber = (
  index: number,
  options: { pageSize?: number | null; currentPage?: number | null },
): number => {
  const pageSize = options?.pageSize || 0
  const currentPage = options?.currentPage || 1

  return index + 1 + pageSize * (currentPage - 1)
}
